import { Component, OnInit } from '@angular/core';
import { HrmsService } from '../hrms.service';

@Component({
  selector: 'app-hrms-header',
  templateUrl: './hrms-header.component.html',
  styleUrls: ['./hrms-header.component.scss']
})
export class HrmsHeaderComponent implements OnInit {
 isCollapsed: boolean = false;
  campusName: string | null;
  userName: string | null;

  constructor(private Service: HrmsService) {
    this.Service.collapsed$.subscribe(data => {
      this.isCollapsed = data;
    });
  }

  ngOnInit(): void {
    this.campusName = localStorage.getItem('campusName');
    this.userName = localStorage.getItem('userName');
  }

  logOut() {
    const logoutPage = localStorage.getItem('logoutPage')
    if (logoutPage) {
      window.location.href = logoutPage;
    }
  }

  toggleCollapse() {
    this.Service.toggleCollapse();
    // const newWidth = this.isCollapsed ? '100%' : '92%';
    // this.Service.updateWidth(newWidth);
  }
}
